import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from '../pages/HomePage/home';
// import CryptocurrencyExchangePage from '../pages/CryptocurrencyExchangeDevelopment/cryptocurrencyExchangePage';
// import BinanceClonePage from '../pages/BinanceCloneScript/binanceClonePage';
// import CryptocurrencyExchangeScriptPage from '../pages/CryptocurrencyExchangeScript/cryptocurrencyExchangeScriptPage';
// import NftMarketplaceScriptPage from '../pages/NftMarketplaceScript/NftMarketplaceScriptPage';
// import UniswapCloneScriptPage from '../pages/UniswapCloneScript/uniswapCloneScriptPage';
// import DAOMakerLaunchpadCloneScriptPage from '../pages/DAOMakerLaunchpadCloneScript/daoMakerLaunchpadCloneScriptPage';
// import HyperledgerFabricCloneScriptPage from '../pages/HyperledgerFabricCloneScript/hyperledgerFabricCloneScript';
// import CryptoLotteryCloneScriptPage from '../pages/CryptoLotteryCloneScript/cryptoLotteryCloneScriptPage';
// import AboutUsPage from '../pages/AboutUs/aboutUs';
// import RealWorldAssetTokenization from '../pages/RealWorldAssetTokenization/realWorldAssetTokenization';
import loader from "../assets/images/Loading_icon.gif";
const Home = lazy(() => import('../pages/HomePage/home'));
const CryptocurrencyExchangePage = lazy(() => import('../pages/CryptocurrencyExchangeDevelopment/cryptocurrencyExchangePage'));
const BinanceClonePage = lazy(() => import('../pages/BinanceCloneScript/binanceClonePage'));
const CryptocurrencyExchangeScriptPage = lazy(() => import('../pages/CryptocurrencyExchangeScript/cryptocurrencyExchangeScriptPage'));
const NftMarketplaceScriptPage = lazy(() => import('../pages/NftMarketplaceScript/NftMarketplaceScriptPage'));
const UniswapCloneScriptPage = lazy(() => import('../pages/UniswapCloneScript/uniswapCloneScriptPage'));
const DAOMakerLaunchpadCloneScriptPage = lazy(() => import('../pages/DAOMakerLaunchpadCloneScript/daoMakerLaunchpadCloneScriptPage'));
const HyperledgerFabricCloneScriptPage = lazy(() => import('../pages/HyperledgerFabricCloneScript/hyperledgerFabricCloneScript'));
const CryptoLotteryCloneScriptPage = lazy(() => import('../pages/CryptoLotteryCloneScript/cryptoLotteryCloneScriptPage'));
const AboutUsPage = lazy(() => import('../pages/AboutUs/aboutUs'));
const RealWorldAssetTokenization = lazy(() => import('../pages/RealWorldAssetTokenization/realWorldAssetTokenization'));
const ComingSoon = lazy(() => import('../pages/ComingSoon/comingSoon'));

const RouterFile: React.FC = () => {
  return (
    <Suspense fallback={
      <div className='hv-100 w-100 d-flex align-items-center justify-content-center'>
          <img src={loader} className='m-auto' />
      </div>
    }>
      <Router>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/crypto-exchange-development-company" element={<CryptocurrencyExchangePage />} />
            <Route path="/binance-clone" element={<BinanceClonePage />} />
            <Route path="/crypto-exchange-script" element={<CryptocurrencyExchangeScriptPage />} />
            <Route path="/nft-marketplace-development" element={<NftMarketplaceScriptPage />} />
            <Route path="/uniswap-clone-script" element={<UniswapCloneScriptPage />} />
            <Route path="/dao-maker-launchpad-clone-script" element={<DAOMakerLaunchpadCloneScriptPage />} />
            <Route path="/hyperledger-fabric-clone-script" element={<HyperledgerFabricCloneScriptPage />} />
            <Route path="/crypto-lottery-clone-script" element={<CryptoLotteryCloneScriptPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/real-world-asset-tokenization" element={<RealWorldAssetTokenization />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default RouterFile;